import { Iterable } from "immutable";

export const selectModalImage = (state) => {
  const image = state.get("imageModal");
  return Iterable.isIterable(image) ? image.toJS() : image;
};
